module.exports = __webpack_public_path__ + "img/4.c1523052.png";